import React, { useState, createContext } from "react";
import { BrowserRouter, Route, Link, Routes } from "react-router-dom";
import Form from "./Form";
import "./App.css";
import CRM from "./CRM";
import RCVerificattion from "./RCVerificattion";
import Step2 from "./RCVerificattion/Step2";
import Lf3Form from "./lf3/index";
import CustomerForm from "./PANRecommendations/CustomerForm";
import Recommendations from "./PANRecommendations/RecommendationsPage";
import AfterOtp from "./PANRecommendations/AfterOtp";
import SCBForm from "./scb/SCBForm";
import SBIForm from "./sbi/SBIForm";
import Hdfc from "./hdfc/Hdfc";
import CreditScoreFaqs from "./PANRecommendations/CreditScoreFaqs";
import FormOld from "./Form/FormOld";
import { FeatureFlagProvider } from "./FeatureFlagContext";
import ConsentForm from "./PANRecommendations/ConsentForm";
import mixpanel from "mixpanel-browser";

// const MIXPANEL_PROJECT_TOKEN = "21f59388a7ec45b1e920ee149f8da188f"
// INFO: This is quick workaround done to remove mixpanel events
const MIXPANEL_PROJECT_TOKEN = "dummy"

mixpanel.init(MIXPANEL_PROJECT_TOKEN); 
// {debug: false, api_host: "https://api-js.mixpanel.com"}

const NavBar = () => (
  <div className="navbar">
    <h3>Task Manager</h3>
    <Link to="/">Current Tasks</Link>
    <Link to="/completed">Completed Tasks</Link>
  </div>
);

const Template = (props) => (
  <div>
    <NavBar />
    <p className="page-info">{props.title}:</p>
    <ul className={props.status}>
      <li>Task 1</li>
      <li>Task 2</li>
      <li>Task 3</li>
    </ul>
  </div>
);

const CurrentTasks = () => <Template title="Current Tasks" status="Current" />;

const CompletedTasks = () => (
  <Template title="Completed Tasks" status="Completed" />
);
const Context = createContext();
function App() {
  const [isMyTeamsFlow, setIsMyTeamsFlow] = useState(false);
  let value = {
    isMyTeamsFlow: isMyTeamsFlow,
    setIsMyTeamsFlow: setIsMyTeamsFlow,
  };

  return (
    <Context.Provider value={value}>
    <FeatureFlagProvider>
      <div className="App-root-div">
      <div className="center-App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Form />} />
            <Route path="/v2" element={<Form />} />
            <Route path="/v2/old" element={<FormOld />} />
            <Route path="/v3" element={<Lf3Form />} />
            <Route path="/v4" element={<Lf3Form />} />
            <Route path="/agentdetails" element={<CRM />} />
            <Route path="/agentcustomerdetails" element={<CRM />} />
            <Route path="/rcv" element={<RCVerificattion />} />
            <Route path="/rcv/step2" element={<Step2 />} />
            <Route path="/customer" element={<CustomerForm />} />
            <Route path="customer/generatebureaureportconsent" element={<ConsentForm />} />
            <Route
              path="/customer/recommendations"
              element={<Recommendations />}
            />
            {/* <Route  path="/customer/recommendation" element={<Recommendation/>}/> */}
            <Route path="/AfterOtp" element={<AfterOtp />} />
            <Route path="/v5" element={<SCBForm />} />
            <Route path="/v6" element={<SBIForm />} />
            <Route path="/eligibility" element={<Hdfc />} />
            <Route
              path="/customer/generatecreditreport"
              element={<CustomerForm isCreditScoreCheck={true} />}
            />
            <Route path="/faqsCreditScore" element={<CreditScoreFaqs />} />
          </Routes>
        </BrowserRouter>
      </div>
      </div>
      </FeatureFlagProvider>
    </Context.Provider>
  );
}

export { App, Context };
